'use strict';

/*@ngInject*/
export function translationService(langConfig, appConfig) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  'ngInject';
  let service = {};
  service.getReference = function(s, o) {
    o = o || service.language;
    if(!s) {
      return appConfig.translate.ERROR;
    }
    // convert indices to properties
    s = s.replace(/\[(\w+)\]/g, '.$1');
    // strip the leading dot
    s = s.replace(/^\./, '');
    var a = s.split('.');
    for(var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if(k in o) {
        o = o[k];
      } else {
        return appConfig.translate.ERROR;
      }
    }
    return o;
  };

  service.init = languageCode => {
    // languageCode is a 2 letter code for the desired language;
    // e.g. EN, DE, FR, AF
    // English is the default
    service.language = langConfig[languageCode] || langConfig.en;
  };

  return service;
}

export default angular.module('fplTruescapeComApp.translation', [])
  .service('TranslationManager', translationService)
  .name;



// WEBPACK FOOTER //
// ./client/components/translation/translation.service.js